import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createGtm } from "vue-gtm";
import VCalendar from "v-calendar";

import "./assets/styles/index.css";
import "v-calendar/dist/style.css";

const app = createApp(App)
  .use(VCalendar, {})
  .use(store)
  .use(router);

app.use(
  createGtm({
    id: "GTM-W8JM858", // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  })
);

app.mount("#app");
